// extracted by mini-css-extract-plugin
export default {"wrapper":"_1jxlH","dot":"_1BIDm","tooltip-content":"H6U9C","tooltipContent":"H6U9C"};